import { MarkerClusterer } from "@googlemaps/markerclusterer";

export default {
    when() {
        return document.querySelectorAll('.section-map-store-locator').length > 0;
    },

    mounted() {
        // store-locator.js
        document.querySelector('.nav').style.position = "absolute";

        class StoreLocator extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({ mode: 'open' });

                // Internal store data and markers array.
                this._stores = [];
                this._markers = [];
                this._labels = this.createObjectFromHtml("projects-labels");
                this._settings = this.createObjectFromHtml("projects-settings");
                this._posttype = document.querySelector('#pagemaptype').innerText || 'projects';
                this._terms = [];
                this._activeTerms = [];
                this._activeStores = [];
                this._currentLang = document.querySelector('#wpml-current-language').innerText; // Fallback en 'fr

                // By default, filter the store list based on visible map markers.
                this._filterMap = this.hasAttribute('filter-map')
                    ? this.getAttribute('filter-map') !== 'false'
                    : true;
            }

            async connectedCallback() {
                // Render the component’s template with a sidebar, map container, and modal.

                // const projectLabels = createObjectFromHtml();
                // console.log(projectLabels)
                this.shadowRoot.innerHTML = `
                    <style>
                    
                        :host {
                            display: block;
                            font-family: Optima, sans-serif;
                            position: relative;
                            box-sizing: border-box;
                        }
                        .heading-2 {
                        font-family: Optima;
                        font-size: 32px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 40px; /* 125% */
                        margin: 0px;
                        }
                        .heading-5 {
                            color: #012D3A;
                            /* Desktop/heading-5 */
                            font-family: Aller;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 120%; /* 21.6px */
                            margin: 0px;
                        }
                        .note-sm {
                            font-family: Aller;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 140%; /* 16.8px */
                            color: #6B7280;
                        }
                        p {
                        margin: 0px; 
                        }
                        .container {
                            display: flex;
                            height: 500px;
                            border: 1px solid #ddd;
                        }
                        .sidebar {
                            width: 30%;
                            overflow-y: auto;
                            padding: 40px 40px 0px 20px;
                            box-sizing: border-box;
                        }
                            
                        .sidebar.right {
                            order: 1;
                            border-right: none;
                            border-left: 1px solid #ddd;
                        }
                        .map {
                            flex: 1;
                        }
                        #search {
                            width: 100%;
                            padding: 8px;
                            margin-bottom: 10px;
                            box-sizing: border-box;
                        }
                        .store-item {
                            padding: 5px;
                            border-bottom: 1px solid #eee;
                            cursor: pointer;
                        }
                        .store-item:hover {
                            background-color: #f0f0f0;
                        }
                        /* Modal styles */
                        .modal {
                            display: none; /* Hidden by default */
                            position: absolute;
                            z-index: 50;
                            right: 0;
                            top: 0;
                            width: 70%;
                            height: 100%;
                            background-color: rgba(0,0,0,0.4);
    
                        }
                        .modal-content {
                            background-color: #FFF;
                            width: calc(100% - 80px); 
                            height: calc(100% - 80px); 
                            position: relative;
                            margin: 40px;
                            box-sizing: border-box;
                            position: relative;
                            overflow-y: scroll;
                        }
                        .inside-content {
                            padding: 40px;
                            padding-bottom: 0px;
                        }
                        .modal-body {
                            overflow-y: scroll;
                        }
                        .close {
                            color: #012D3A;
                            float: right;
                            font-size: 28px;
                            font-weight: bold;
                            position: absolute;
                            top: 10px;
                            right: 10px;
                            cursor: pointer;
                        }
                        .store-item {
                            border-radius: 6px;
                            background: var(--white, #FFF);
                            padding: 16px 24px;
                            /* TW-Shadows/base */
                            box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.10);
                            margin-bottom: 12px;
                        }
                             .store-item:hover {
                                filter: brightness(95%);
                            }
                        .category {
                            font-family: Aller;
                            font-size: 11px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 140%;
                             border-radius: 12px;
                            border: 1px solid rgba(0, 150, 190, 0.25);
                            padding: 2px 8px;
                            margin-top: 8px;
                            max-width: max-content;
                        }
                        .two-grid {
                            display: grid;
                            grid-template-columns: 1fr 1fr; /* Two equal sections */
                            gap: 10px; /* Optional: to add space between sections */
                        }
                        .note-base {
                            color: #6B7280;
                            /* Desktop/note-base */
                            font-family: Aller;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 140%; /* 19.6px */
                        }
                        .tooltip {
                            position: absolute;
                            top: 22px;
                            right: 16px;
                            width: 12px;
                            height: 12px;
                            border-radius: 9999999px;
                            background-color: #0096BE;
                        }
                        .modal-link {
                            position: sticky; 
                            background-color: #FFF;
                            bottom: 0; left: 0; 
                            width: 100%; 
                            min-height: 20px;
                            display: block; 
                            width: 100%;
                            z-index: 50;
                        }
                        .modal-link a {
                            text-decoration: none;
                        }

                        .link-pad {

                            padding: 16px 40px;
                        }

                        // DROPDOWN
                        .text-black {
                            color: black;
                        }
                        .cursor-pointer {
                            cursor: pointer;
                        }
                        .dropdown-content {
                            padding: 24px;
                            text-align: left;
                        }
                       
                        .relative {
                            position: relative;
                        }

                        .dropdown-button-click {
                        margin-top: 24px;
                        margin-bottom: 16px;
                            display: flex;
                            align-items: center;
                            gap: 4px;
                            border-radius: 5px;
                            border: 1px solid var(--Primary-500, #0096BE);
                            max-width: max-content;

                            padding: 10px 16px;
                        }

                        .dropdown-content-click {
                            position: absolute;
                            top: 3rem; /* top-12 */
                            left: 0;
                            display: none; /* hidden */
                            width: 247px; 
                            min-width: min-content;
                            flex-direction: column;
                            align-items: center;
                            justify-content: space-around;
                            background-color: white;
                            text-align: right;
                            border-radius: 16px;
                            border: 1px solid #E5E7EB;
                            background: var(--white, #FFF);
                            box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.10), 0px 10px 10px -5px rgba(0, 0, 0, 0.04);


                            z-index: 50;
                        }

                        .dropdown-content-click a {
                            display: flex;
                            width: 100%;
                            flex-grow: 1;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                            text-decoration: none;
                            color: inherit;
                        }

                        .dropdown-content-click a + a {
                            border-top: 1px solid #e5e7eb;
                        }

                        
                        .dropdown-active {
                            display: flex;
                        }
                        .label {
                            color: #374151;
                            font-family: Aller;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 140%; 
                        }

                        .map-footnote {
                            padding: 4px 8px;
                            position: absolute;
                            bottom: 8px;
                            left: 8px;
                            max-width: 50%;
                            z-index: 40;
                            background: rgba(255, 255, 255, 0.80);
                        }

                        .map {
                        width: 100%;
                         height: 100%;
                        }

                        @media screen and (max-width: 1024px) {
                            .container {
                                display: block;
                                height: auto;
                                width: 100%;
                                border: 1px solid #ddd;
                            }
                            .sidebar {
                                width: 100%;
                                overflow-y: visible;
                            }
                            .map {
                                height: 80vh;
                            }

                            .two-grid {
                                display: block;
                                grid-template-columns: 1fr 1fr; /* Two equal sections */
                                gap: 10px; /* Optional: to add space between sections */
                            }        
                            #storeList {
                                display: none;
                            }
                            .modal {
                                width: 100%;
                                height: 100%;
                                background-color: rgba(0,0,0,0.4);
                            }
                            .inside-content {
                                padding: 40px 10px 0px 10px;
                            }
                            .modal-content {
                                margin: 20px;
                                width: calc(100% - 40px); 
                                height: calc(100% - 40px); 
                            }
                            .link-pad {
                                padding: 16px 10px;
                            }
                                 .map-footnote {
                            max-width: calc(100% - 180px);
                        }

                        }


                        @keyframes bounce {
                            0%, 100% { top: 0; }
                            50% { top: -10px; }
                        }


                        .bouncing {
                            animation: bounce 0.5s infinite alternate ease-in-out;
                        }
                    </style>
                    <div class="container">
                    <div class="sidebar" id="sidebar">
                            <h2 class="heading-2">${this._settings.title}</h2>
                            <div>${this._settings.content}</div>
                            <div class="relative">
                                <div class="text-black dropdown-button-click cursor-pointer note-sm">
                                    ${this._labels.button_filter_projects}
                                
                                    <svg width="20px" height="20px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.791 11.529a.733.733 0 01-.537-.223L4.223 7.283a.745.745 0 010-1.065.751.751 0 011.057 0l3.51 3.511 3.512-3.511a.751.751 0 011.057 0 .748.748 0 010 1.065l-4.023 4.023a.753.753 0 01-.535.223z" fill="#494c4e"/>
                                    </svg>
                                </div>
                                <div
                                    class="dropdown-content-click absolute top-12 left-0 hidden h-24 w-48 min-w-min flex-col items-center justify-around bg-white text-right shadow-md"
                                >
                                <div class="dropdown-content">
                                
                                </div>
                                </div>
                            </div>
                        <div style="margin-top: 12px;" id="storeList"></div>
                    </div>
                    <div style="position: relative; flex: 1; width: 100%; height: 100%;" >
                    <div class="map" id="map" >
                    
                    
                    </div>
                    <div class="map-footnote note-sm">${this._settings.map_footnote}</div>
                    </div>

                    </div>
                    <!-- Modal for showing store details -->
                    <div id="modal" class="modal">
                        <div style="position: relative" class="modal-content">
                            <div>
                                <span id="modal-close" class="close">&times;</span>
                                <div id="modal-body"></div>
                            </div>
                             
                        </div>
                      
                    </div>
                `;

                // Adjust sidebar position if attribute "sidebar-position" is set to "right"
                const sidebarPos = this.getAttribute('sidebar-position') || 'left';
                const sidebarEl = this.shadowRoot.getElementById('sidebar');
                if (sidebarPos === 'right') {
                    sidebarEl.classList.add('right');
                    // Reorder the elements so that the sidebar appears on the right.
                    const container = this.shadowRoot.querySelector('.container');
                    container.appendChild(sidebarEl);
                }

                this.fetchAndInitStores();

                // Set up modal close functionality.
                const modalClose = this.shadowRoot.getElementById('modal-close');
                const modal = this.shadowRoot.getElementById('modal');
                modalClose.addEventListener('click', () => this.hideModal());
                // If clicking outside the modal content, close the modal.
                modal.addEventListener('click', (e) => {
                    if (e.target === modal) {
                        this.hideModal();
                    }
                });
                this.dropdownFilter();
            }

            async fetchAndInitStores() {
                try {
                    this._stores = await this.fetchAllProjects(); // Store the fetched data
                    this._activeStores = this._stores;
                    this.initMap(); // Initialize the map with the updated store data
                    this.renderStoreList(this._stores); // Populate the store list

                } catch (error) {
                    console.error("Error fetching stores:", error);
                }
            }

            async fetchAllProjects() {
                let allProjects = [];
                let page = 1;
                let totalPages = 1; // Start with 1 to enter the loop
                console.log('posttype', this._posttype);
                do {
                    const response = await fetch(
                        `/wp-json/wp/v2/${this._posttype}/?_fields=id,title,acf,type-${this._posttype}&acf_format=standard&per_page=100&page=${page}&lang=${this._currentLang}`
                    );

                    if (!response.ok) {
                        console.error(`Error fetching page ${page}:`, response.statusText);
                        break;
                    }

                    const projects = await response.json();
                    allProjects = allProjects.concat(projects);

                    // Get total pages from response headers
                    totalPages = parseInt(response.headers.get('X-WP-TotalPages'), 10) || 1;
                    page++;
                } while (page <= totalPages);

                let allPositions = [];
                let projectsTemp = [];

                const typePostType = `type-${this._posttype}`;

                // Get unique term IDs from all projects
                const termIds = [...new Set(allProjects.flatMap(project => project[typePostType]))];

                // Fetch all term details in one request
                const termsResponse = await fetch(`/wp-json/wp/v2/type-${this._posttype}?include=${termIds.join(',')}&_fields=id,name,acf&lang=${this._currentLang}`);
                const terms = await termsResponse.json();
                this._terms = terms;
                this._activeTerms = terms;
                // Create a map of term ID -> term details
                const termMap = Object.fromEntries(terms.map(term => [
                    term.id,
                    { id: term.id, name: term.name, category_color: term.acf?.category_color || "#0096BE" } // Default color if missing
                ]));

                // Attach term names & category colors to projects
                const enrichedProjects = allProjects.map(project => ({
                    ...project,
                    typeProjectDetails: project[typePostType].map(id => termMap[id] || { name: "Unknown", category_color: "#0096BE" })
                }));


                let dropdownContent = this.shadowRoot.querySelector('.dropdown-content');

                if (dropdownContent) {
                    const form = document.createElement("form");

                    const style = document.createElement('style');

                    terms.forEach(category => {
                        const label = document.createElement("label");
                        label.style.marginTop = "12px";
                        label.classList.add('label');
                        const span = document.createElement("span");
                        const checkbox = document.createElement("input");

                        checkbox.type = "checkbox";

                        checkbox.name = "category";
                        checkbox.value = category.id;
                        checkbox.id = `cat-${category.id}`;
                        checkbox.checked = true;

                        // style.textContent = `

                        //     input[type="checkbox"]#cat-${category.id}:checked {
                        //         accent-color: ${category.acf.category_color};
                        //     }
                        //     `;
                        checkbox.style.accentColor = `${category.acf.category_color}`;
                        this.shadowRoot.appendChild(style);
                        checkbox.style.backgroundColor = "red";


                        label.appendChild(checkbox);
                        label.appendChild(document.createTextNode(" " + category.name));

                        form.appendChild(label);
                        form.appendChild(document.createElement("br"));
                    });

                    dropdownContent.appendChild(form);
                }


                enrichedProjects.map((project, id) => {
                    allPositions.push({
                        lat: project.acf.position.lat,
                        lng: project.acf.position.lng
                    })
                    if (project.acf.position) {
                        if (project.acf.position.lat && project.acf.position.lng) {

                            projectsTemp.push({
                                id: id,
                                name: project.acf.title,
                                image: project.acf.image,
                                image_footnote: project.acf.image_footnote,
                                countries: project.acf.countries,
                                description: project.acf.description,
                                funded_by: project.acf.funded_by,
                                implemented_by: project.acf.implemented_by,
                                link: project.acf.link,
                                supported_by: project.acf.supported_by,
                                name: project.acf.title,
                                lat: project.acf.position.lat,
                                lng: project.acf.position.lng,
                                category: project.typeProjectDetails,
                            });
                        }
                    }
                });
                return projectsTemp;
            }

            initMap() {
                // Get the container for the map from the shadow DOM.
                const mapContainer = this.shadowRoot.getElementById('map');
                if (!mapContainer) {
                    console.error("Map container not found!");
                    return;
                }
                // Initialize the Google Map (assumes google.maps is available)
                this._map = new google.maps.Map(mapContainer, {
                    center: { lat: 37.7749, lng: -122.4194 },
                    zoom: 13,
                    mapId: '3ce86697f4f6c570',
                    mapTypeControl: false,  // Removes the map type control (Plan/Satellite)
                    fullscreenControl: false,  // Removes the fullscreen control
                    streetViewControl: false,  // Removes the street view control

                });

                const bounds = new google.maps.LatLngBounds(); // Create bounds object
                const markers = []; // ➜ tableau pour clusterer

                // Move marker if same position
                const getOffsetPosition = (lat, lng, index) => {
                    const offset = 0.005; //
                    return {
                        lat: lat + (Math.random() - 0.5) * offset,
                        lng: lng + (Math.random() - 0.5) * offset,
                    };
                };

                // Create a marker for each store.
                this._stores.forEach(store => {
                    let position = { lat: store.lat, lng: store.lng };

                    const duplicates = this._stores.filter(s => s.lat === store.lat && s.lng === store.lng);
                    if (duplicates.length > 1) {
                        const index = duplicates.findIndex(s => s.id === store.id);
                        position = getOffsetPosition(store.lat, store.lng, index);
                    }

                    // Create a custom marker element
                    const markerElement = document.createElement("div");
                    markerElement.classList.add("custom-marker");
                    markerElement.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
        <path d="M12 2C8 2 5 5.5 5 9c0 4 4 9 7 12 3-3 7-8 7-12 0-3.5-3-7-7-7z" 
            fill="${store.category.length > 0 ? store.category[0].category_color : '#0096BE'}" 
            stroke="#FFF" stroke-width="2"/>
    </svg>`;

                    // Create the AdvancedMarkerElement
                    const marker = new google.maps.marker.AdvancedMarkerElement({
                        position: position,
                        // map: this._map,
                        title: store.name,
                        content: markerElement, // Attach the custom HTML element
                    });


                    // Save a reference to the store id (used later for linking to the list)
                    marker.storeId = store.id;

                    // When clicking on a marker, scroll the list to the corresponding store item,
                    // highlight the store in the list, and display the modal with store details.
                    marker.addListener('gmp-click', () => {
                        this.zoomInOnPin(store.id);  // Zoom in on pin click
                        this.scrollToStoreItem(store.id);

                        this.showModal(store);
                    });


                    markers.push(marker); // for MarkerClusterer
                    this._markers.push({ marker, store });

                    bounds.extend(position); // Add store location to bounds
                });

                // display numbers if several markers together
                new MarkerClusterer({
                    map: this._map,
                    markers,
                });


                this._map.fitBounds(bounds);
                // When the map stops moving (idle), if the feature is enabled, filter the list
                // to show only stores with markers currently in view.
                this._map.addListener('idle', () => {
                    if (this._filterMap) {
                        this.filterStoresByMapBounds();
                    }
                });

                // FIlter the stores
                this.shadowRoot.querySelectorAll("input[name='category']").forEach(checkbox => {
                    checkbox.addEventListener("change", () => {
                        const checkedCategories = [];
                        this.shadowRoot.querySelectorAll("input[name='category']").forEach((input) => {
                            if (input.checked) {
                                checkedCategories.push(parseInt(input.value));  // Store the checked category IDs as integers
                            }
                        })

                        this._activeStores = this._stores.filter(store =>
                            store.category.some(cat => checkedCategories.includes(cat.id))
                        );
                        this.renderStoreList(this._activeStores);
                        this.updateMarkersVisibility(this._activeStores);
                    });
                });
            }

            renderStoreList(stores) {
                const storeListContainer = this.shadowRoot.getElementById('storeList');
                storeListContainer.innerHTML = '';

                stores.forEach(store => {
                    const div = document.createElement('div');
                    div.className = 'store-item';
                    div.dataset.storeId = store.id;
                    div.style.borderLeft = `5px solid ${store.category.length > 0 ? store.category[0].category_color : '#0096BE'}`;
                    div.style.position = `relative`;

                    div.innerHTML = `
                    <div style="display: none; background-color: ${store.category.length > 0 ? store.category[0].category_color : '#0096BE'};" class="tooltip"></div>
                    <p class="heading-5">${store.name}</p>
                    ${store.countries !== '' ? `<p class="note-sm" style="margin-top: 8px;">${this._labels.countries}: <strong>${store.countries}</strong></p>` : ''}
                    ${store.implemented_by.length > 0 ? `<p class="note-sm">${this._labels.implemented_by}: <strong>${(Array.isArray(store.implemented_by) ? store.implemented_by : [])
                            .map(item => ` ${item.title}`)
                            .join('')}</strong></p>` : ''}
                        
                    ${store.category.length > 0 ? `<p style="color: ${store.category.length > 0 ? store.category[0].category_color : '#0096BE'}; border-color: ${store.category.length > 0 ? store.category[0].category_color : '#0096BE'};" class="category cat-border mt-2">${store.category.length > 0 ? store.category[0].name : ''}</p>` : ''}
                    
                       `;

                    // When hovering over a list item, highlight its marker.
                    // When hovering over a list item, highlight its marker.
                    div.addEventListener('mouseenter', () => {
                        this.highlightMarker(store.id);

                    });

                    div.addEventListener('mouseleave', () => {
                        this.unhighlightMarker(store.id);
                    });

                    // When clicking on a list item, center the map on its marker.
                    // Also display the modal with the store’s detailed information.
                    div.addEventListener('click', () => {
                        this.zoomInOnPin(store.id);  // Zoom in on pin click
                        this.centerMapOnStore(store.id);
                        this.showModal(store);
                        this.highlightStore(store.id);
                    });

                    storeListContainer.appendChild(div);



                });

            }

            dropdownFilter() {
                // Dropdown filter
                let button = this.shadowRoot.querySelector(".dropdown-button-click");
                let dropdown = this.shadowRoot.querySelector(".dropdown-content-click");
                let isOpen = false;

                document.addEventListener(
                    "click",
                    (event) => {
                        const withinButton = event.composedPath().includes(button);
                        const withinDropdown = event.composedPath().includes(dropdown);

                        if (withinButton) {
                            // Toggle dropdown when clicking the button
                            isOpen = !isOpen;
                            dropdown.style.display = isOpen ? "block" : "none";
                        } else if (!withinDropdown) {
                            // Close dropdown when clicking outside both button and content
                            dropdown.style.display = "none";
                            isOpen = false;
                        }
                    },
                    { passive: true }
                );


            }

            updateMarkersVisibility(filteredStores) {
                // Show only markers for stores that are in the filtered list.
                const filteredIds = filteredStores.map(store => store.id);
                console.log(filteredIds);

                this._markers.forEach(({ marker, store }) => {
                    marker.style.display = 'block';
                    if (!filteredIds.includes(store.id)) {
                        marker.style.display = 'none';
                    }
                });
            }

            filterStoresByMapBounds() {
                // Get the current map bounds.
                const bounds = this._map.getBounds();
                if (!bounds) return;

                // Filter the stores to those whose markers are within the current map view.
                const visibleStores = this._activeStores.filter(store => {
                    const pos = new google.maps.LatLng(store.lat, store.lng);
                    return bounds.contains(pos);
                });

                this.renderStoreList(visibleStores);
            }

            highlightMarker(storeId) {
                console.log("Highlighting marker for storeId:", storeId);
                const markerObj = this._markers.find(m => m.store.id == storeId);
                if (markerObj) {
                    markerObj.marker.element.classList.add("bouncing");
                }
            }

            unhighlightMarker(storeId) {
                const markerObj = this._markers.find(m => m.store.id == storeId);
                if (markerObj) {
                    markerObj.marker.element.classList.remove("bouncing");
                }
            }



            highlightStore(storeId) {
                // In the sidebar list, add a highlight style to the selected store item.
                const storeItems = this.shadowRoot.querySelectorAll('.store-item');
                storeItems.forEach(item => {
                    item.querySelector('.tooltip').style.display = item.dataset.storeId == storeId ? 'block' : 'none';
                    item.style.backgroundColor = item.dataset.storeId == storeId ? item.querySelector('.tooltip').style.backgroundColor.replace("rgb", "rgba").replace(")", ", 0.08)") : '#FFF';
                });
            }

            unHighlightStore() {
                // In the sidebar list, add a highlight style to the selected store item.
                const storeItems = this.shadowRoot.querySelectorAll('.store-item');
                storeItems.forEach(item => {
                    item.querySelector('.tooltip').style.display = 'none';
                });
            }


            scrollToStoreItem(storeId) {
                // Scroll the sidebar to reveal the clicked store.
                // const storeItem = this.shadowRoot.querySelector(`.store-item[data-store-id="${storeId}"]`);
                // if (storeItem) {
                //     storeItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                //     this.highlightStore(storeId);
                // }
            }

            centerMapOnStore(storeId) {
                // Center the map on the store's marker when its list item is clicked.
                // const store = this._stores.find(s => s.id == storeId);
                // if (store) {
                //     this._map.panTo({ lat: store.lat, lng: store.lng });
                //     this.highlightMarker(storeId);
                //     // Optionally, you can open an InfoWindow here.
                // }
            }

            showModal(store) {
                this.highlightStore(store.id);
                const modal = this.shadowRoot.getElementById('modal');
                const modalBody = this.shadowRoot.getElementById('modal-body');

                // Populate the modal with detailed store information.
                let catColor = store.category.length > 0 ? store.category[0].category_color : '';
                modalBody.innerHTML = `
                <div class="inside-content">
                    <div class="two-grid" style="padding-bottom: 32px; margin-bottom: 32px; border-bottom: 1px solid #E5E7EB">
                        <div>
                            
                            <h2 class="heading-2">${store.name}</h2>
                            <p style="margin-top: 18px;" class="note-base" style="margin-top: 8px;">${store.countries}</p>
                            
                            ${store.category.length > 0 ? `<p style="margin-top: 10px ;color: ${catColor}; border-color: ${catColor};" class="category cat-border">${store.category.length > 0 ? store.category[0].name : ''}</p>` : ''}

                            ${store.funded_by !== '' ?
                        `<p style="margin-top: 18px ;color: ${catColor};" class="note-sm">${this._labels.funded_by}: </p>
                            <p style="margin-top: 4px; color: #012D3A;" class="note-base">${store.funded_by}</p>` : ''}

                            ${store.supported_by !== '' ?
                        `<p style="margin-top: 18px ;color: ${catColor};" class="note-sm">${this._labels.supported_by}: </p>
                            <p style="margin-top: 4px; color: #012D3A;" class="note-base">${store.supported_by}</p>` : ''}
                            ${store.implemented_by.length > 0 ?
                        `<p style="margin-top: 12px ;color: ${catColor};" class="note-sm">${this._labels.implemented_by}: </p>` : ''}


                            <div style="margin-top: 4px; display: grid; grid-template-columns: repeat(${store.implemented_by.length == 1 ? 1 : store.implemented_by.length == 2 ? 2 : 3}, 1fr); gap: 12px; color: #012D3A;" class="note-base">

                        ${(Array.isArray(store.implemented_by) ? store.implemented_by : [])
                        .map((item, index) => `
                                <div>
                                    <p>${item.title}</p> 
                                    ${item.image ? `<img src="${item.image}" alt="${item.name}" style="margin-top: 16px; width:80%; max-width: 210px; height:auto; object-fit: contain; margin-bottom: 10px;">` : ''}
                                </div>
                            `)
                        .join('')}
                    </div>
                        </div>
                        <div>
                            ${store.image ? `<img src="${store.image}" alt="${store.name}" style="width:100%; height:auto; object-fit: contain; margin-bottom: 10px;">` : ''}
                            <p class="note-sm">${store.image_footnote}</p>
                        </div>
                    </div>
                    ${store.description ? `
                    <p style="margin-top: 18px ;color: ${catColor};" class="note-sm">${this._labels.description}: </p>
                    <div style="margin-top: 8px; padding-bottom: 40px;">${store.description}</div>
                    </div>
                    ` : ''}
                    ${store.link ? `
                        <div style="background-color: #FFF" class="modal-link">
                            <a style="display:block;background-color: ${this.hexToRgba(catColor, 0.1)}; width: 100%; height: 100%;" href="${store.link.url}" target="${store.link.target}" >
                            <p class="link-pad">
                                <span style="color: ${catColor}" class="note-base">${this._labels.learn_more_link}: </span><span style="color: #012D3A" class="modal-link-title note-base">${store.link.title}</span>
                                </p>
                            </a>
                        </div>
                   ` : ''
                    }
                `;
                modal.style.display = 'block';

            }

            hideModal() {
                const modal = this.shadowRoot.getElementById('modal');
                modal.style.display = 'none';
                this.unHighlightStore();
            }

            zoomInOnPin(storeId) {
                // Store the previous zoom level before zooming in
                // this._previousZoom = this._map.getZoom();

                // const store = this._stores.find(s => s.id == storeId);
                // if (store) {
                //     this._map.panTo({ lat: store.lat, lng: store.lng });
                //     this._map.setZoom(8);  // Zoom in to level 15 when the pin is clicked
                // }
            }

            // Observe attributes so that external changes can update behavior.
            static get observedAttributes() {
                return ['sidebar-position', 'filter-map'];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                if (name === 'filter-map') {
                    this._filterMap = newValue !== 'false';
                }
                // For simplicity, changes to sidebar-position are handled only on initial render.
            }
            createObjectFromHtml(htmlID) {
                const labelsContainer = document.getElementById(htmlID);
                const labels = labelsContainer.querySelectorAll("div");
                let dataObject = {};

                labels.forEach(label => {
                    dataObject[label.id] = label.textContent.trim();
                });

                return dataObject;
            }
            hexToRgba(hex, alpha = 1) {
                // Remove the '#' if it's there
                hex = hex.replace(/^#/, '');

                // Parse r, g, b values
                let r, g, b;

                if (hex.length === 3) {
                    // Convert shorthand hex (e.g., #abc) to full form (e.g., #aabbcc)
                    r = parseInt(hex[0] + hex[0], 16);
                    g = parseInt(hex[1] + hex[1], 16);
                    b = parseInt(hex[2] + hex[2], 16);
                } else if (hex.length === 6) {
                    r = parseInt(hex.substring(0, 2), 16);
                    g = parseInt(hex.substring(2, 4), 16);
                    b = parseInt(hex.substring(4, 6), 16);
                } else {
                    throw new Error("Invalid HEX color.");
                }

                return `rgba(${r}, ${g}, ${b}, ${alpha})`;
            }
        }

        customElements.define('store-locator', StoreLocator);
    },
};
